import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue')
  },
  {
    path: '/getsionale',
    name: 'Gestionale',
    component: () => import(/* webpackChunkName: "about" */ '../views/Gestionale.vue')
  },
  {
    path: '/visualizzaSala',
    name: 'VisualizzaSala',
    component: () => import(/* webpackChunkName: "about" */ '../views/VisualizzaSala.vue')
  },
  {
    path: '/client',
    name: 'Benvenuto',
    component: () => import(/* webpackChunkName: "about" */ '../views/Benvenuto.vue')
  },
  {
    path: '/editMenu',
    name: 'EditMenu',
    component: () => import(/* webpackChunkName: "about" */ '../views/EditMenu.vue')
  },
  {
    path: '/menu',
    name: 'Menu',
    component: () => import(/* webpackChunkName: "about" */ '../views/Menu.vue')
  },
  {
    path: '/mapprod',
    name: 'MappaturaP',
    component: () => import(/* webpackChunkName: "about" */ '../views/MappaturaP.vue')
  },
  {
    path: '/tabprod',
    name: 'TabellaProdotti',
    component: () => import(/* webpackChunkName: "about" */ '../views/TabellaMapP.vue')
  },
  {
    path: '/magazzino',
    name: 'Magazzino',
    component: () => import(/* webpackChunkName: "about" */ '../views/Magazzino.vue')
  },
  {
    path: '/mapprodotti',
    name: 'MappaturaPiatti',
    component: () => import(/* webpackChunkName: "about" */ '../views/MappaturaPiatti.vue')
  },
  {
    path: '/prodottidaordinare',
    name: 'Ordina',
    component: () => import(/* webpackChunkName: "about" */ '../views/Ordina.vue')
  },
  {
    path: '/prodottidacaricare',
    name: 'Carica',
    component: () => import(/* webpackChunkName: "about" */ '../views/Carica.vue')
  },
  {
    path: '/analisiCosti',
    name: 'analisiCosti',
    component: () => import(/* webpackChunkName: "about" */ '../views/AnalisiCosti.vue')
  },
  {
    path: '/riepilogoAndamento',
    name: 'riepilogoAndamento',
    component: () => import(/* webpackChunkName: "about" */ '../views/RiepilogoAndamento.vue')
  },
  {
    path: '/aggiunte',
    name: 'aggiunte',
    component: () => import(/* webpackChunkName: "about" */ '../views/Aggiunte.vue')
  },
  {
    path: '/stampaprenotati',
    name: 'stampaPrenotati',
    component: () => import(/* webpackChunkName: "about" */ '../views/StampaPrenotati.vue')
  },
  {
    path: '/gestionecredenziali',
    name: 'GestioneCredenziali',
    component: () => import(/* webpackChunkName: "about" */ '../views/GestioneCredenziali.vue')
  },
  {
    path: '/changelayout',
    name: 'ChangeLayout',
    component: () => import(/* webpackChunkName: "about" */ '../views/ChangeLayout.vue')
  },
  {
    path: '/stampanti',
    name: 'Stampanti',
    component: () => import(/* webpackChunkName: "about" */ '../views/Stampanti.vue')
  },
  {
    path: '/gestione-asporto',
    name: 'GestioneAsporto',
    component: () => import(/* webpackChunkName: "gestione-asporto" */ '../views/GestioneAsporto.vue')
  },
  {
    path: '/ordine-asporto',
    name: 'OrdineAsporto',
    component: () => import(/* webpackChunkName: "asporto" */ '../views/OrdineAsporto.vue')
  },
  {
    path: '/invoices',
    name: 'InvoiceManager',
    component: () => import(/* webpackChunkName: "invoice-manager" */ '../views/InvoiceManager.vue')
  },
  {
    path: '/social',
    name: 'Social',
    component: () => import(/* webpackChunkName: "social" */ '../views/Social.vue')
  },
  {
    path: '/report-ai',
    name: 'ReportAI',
    component: () => import(/* webpackChunkName: "about" */ '../views/ReportAI.vue')
  },
  {
    path: '/pagamento-successo',
    name: 'PagamentoSuccesso',
    component: () => import(/* webpackChunkName: "asporto" */ '../views/PagamentoSuccesso.vue')
  },
  {
    path: '/pagamento-fallito',
    name: 'PagamentoFallito',
    component: () => import(/* webpackChunkName: "asporto" */ '../views/PagamentoFallito.vue')
  },
  {
    path: '/sala',
    name: 'Sala',
    component: () => import(/* webpackChunkName: "about" */ '../components/Sala.vue')
  },
  {
    path: '/traduci',
    name: 'Traduci',
    component: () => import(/* webpackChunkName: "about" */ '../views/Traduci.vue')
  },
  {
    path: '/allergeni',
    name: 'Allergeni',
    component: () => import(/* webpackChunkName: "about" */ '../views/Allergeni.vue')
  },
  {
    path: '/digitalizzazione',
    name: 'Digitalizzazione',
    component: () => import(/* webpackChunkName: "about" */ '../views/Digitalizzazione.vue')
  },
  {
    path: '/tempi-di-attesa',
    name: 'TempiDiAttesa',
    component: () => import(/* webpackChunkName: "about" */ '../views/TempiDiAttesa.vue')
  },
  {
    path: '/prenotazioni-setting',
    name: 'PrenotazioniSetting',
    component: () => import(/* webpackChunkName: "about" */ '../views/PrenotazioniSetting.vue')
  },
  {
    path: '/marcia',
    name: 'Marcia',
    component: () => import(/* webpackChunkName: "about" */ '../views/Marcia.vue')
  },
  {
    path: '/chiamate-cameriere',
    name: 'ChiamateCameriere',
    component: () => import(/* webpackChunkName: "about" */ '../views/ChiamateCameriere.vue')
  },
  {
    path: '/impostazioni',
    name: 'Impostazioni',
    component: () => import(/* webpackChunkName: "impostazioni" */ '../views/Impostazioni.vue')
  },
  {
    path: '/riepilogo-ordini',
    name: 'RiepilogoOrdini',
    component: () => import(/* webpackChunkName: "about" */ '../views/RiepilogoOrdini.vue')
  },
  {
    path: '/statistiche',
    name: 'Statistiche',
    component: () => import(/* webpackChunkName: "about" */ '../views/Statistiche.vue')
  },
  {
    path: '/documenti-fiscali',
    name: 'DocumentiFiscali',
    component: () => import(/* webpackChunkName: "about" */ '../views/DocumentiFiscali.vue')
  },
  {
    path: '/pagamenti',
    name: 'Pagamenti',
    component: () => import(/* webpackChunkName: "about" */ '../views/Pagamenti.vue')
  }
]


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
